<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Bank Details</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="bankDetails" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-6 col-form-label">Name on Account</label>
      <div class="col-sm-6">
        <input type="text" 
               class="form-control" 
               formControlName="nameOnCard" 
               (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-6 col-form-label">Bank Name</label>
      <div class="col-sm-6">
        <input type="text" 
               class="form-control" 
               formControlName="bankName" 
               (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-6 col-form-label">Account Number</label>
      <div class="col-sm-6">
        <input type="text" 
               class="form-control" 
               formControlName="accountNumber" 
               (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-6 col-form-label">Sort Code</label>
      <div class="col-sm-6">
        <input type="text" 
               class="form-control" 
               formControlName="sortCode" 
               (change)="updateField()">
      </div>
    </div>

  </form>
</div>